export default __webpack_public_path__ + "static/media/loader.1bcd0c30.gif";